import RailyOfficerAddRequest from "../../api/raily/raily-officer/add/raily-officer-add.request";
import railyOfficerApiService from "../../api/raily/raily-officer/raily-officer-api.service";
import dataLoadErrorFactory from "../../utils/data-load-error/data-load-error.factory";
import handleErrorFactory from "../../utils/handle-error/handle-error.factory";
import HttpError from "../../utils/http/http.error";
import RailyOfficerAddError from "./add/raily-officer-add-error";
import RailyOfficerAddParams from "./add/raily-officer-add-params";
import railyOfficerAddParamsFactory from "./add/raily-officer-add-params.factory";

const add = async (
  params: RailyOfficerAddParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: RailyOfficerAddRequest =
    railyOfficerAddParamsFactory.create(params);

  try {
    const response = await railyOfficerApiService().add(request, abortSignal);

    if (response.status !== 201) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | RailyOfficerAddError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const railyOfficerService = {
  add,
};

export default railyOfficerService;
